import React, {Component} from 'react'
import styles from './FJCustomScroll.module.less'
import {Scrollbars} from 'react-custom-scrollbars'
import BezierEasing from 'bezier-easing'
import FJCoreUtil from "../../core/util/FJCoreUtil";
import classNames from 'classnames'

class FJCustomScroll extends Component {

  constructor(props) {
    super(props);
    this.scroll = React.createRef();
  }

  componentDidMount() {

  }

  componentDidUpdate(preProps) {
    if ((preProps.active !== this.props.active) && this.props.active) {
      this.scroll.current.scrollToTop();
    }
  }

  getScroll = () => {
    return this.scroll;
  };

  scrollToBottom = () => {
    let {clientHeight, scrollHeight} = this.scroll.current.getValues();
    this.scrollTop(scrollHeight - clientHeight);
  };


  onScrollFrame = (data) => {
    if (!this.requestAni && this.props.onScrollFrame) {
      this.props.onScrollFrame(data);
    }
  };

  /**
   * @description 返回scrollleft
   * @returns {*}
   */
  getScrollLeft = () => {
    return this.scroll.current.getScrollLeft();
  };

  /**
   * @description 返回scrolltop
   * @returns {*}
   */
  getScrollTop = () => {
    return this.scroll.current.getScrollTop();
  };

  /**
   * @description 设置横向滚动条位置
   * @param left
   * @param flush
   */
  scrollLeft = (left, flush) => {
    if (this._isDealingLeft)
      return;
    if (flush) {
      this.scroll.current.scrollLeft(left);
    } else {
      this.curLeft = this.getScrollLeft();
      this.left = left;
      this.easing = BezierEasing(0.165, 0.84, 0.44, 1);
      if (this.requestAniLeft) {
        window.cancelAnimationFrame(this._animationLeft);
        this.requestAniLeft = null;
      }
      this.doneLeft = false;
      this.requestAniLeft = window.requestAnimationFrame(this._animationLeft);
      this._isDealingLeft = true;
    }
  };

  /**
   * @description 添加滚动的动画
   * @param timeStamp
   * @private
   */
  _animationLeft = (timeStamp) => {
    if (this.doneLeft) {
      this.startTimeLeft = 0;
      this.doneLeft = false;
      window.cancelAnimationFrame(this._animationLeft);
      this.requestAniLeft = null;
      this._isDealingLeft = false;
      return;
    }
    this.startTimeLeft = this.startTimeLeft || timeStamp;
    let progress = (timeStamp - this.startTimeLeft) / 300;
    progress = FJCoreUtil.valueOfInterval(progress, 0, 1);

    let offset = (this.left - this.curLeft) * this.easing(progress) + this.curLeft;
    this.scroll.current.scrollLeft(offset);

    if (progress === 1) {
      this.doneLeft = true;
    }
    this.requestAniLeft = window.requestAnimationFrame(this._animationLeft)
  };

  /**
   * @description 设置纵向滚动条位置
   * @param top
   * @param flush
   */
  scrollTop = (top, flush) => {
    if (this._isDealingTop)
      return;
    if (flush) {
      this.scroll.current.scrollTop(top);
    } else {
      this.curTop = this.getScrollTop();
      this.top = top;
      this.easing = BezierEasing(0.165, 0.84, 0.44, 1);
      if (this.requestAniTop) {
        window.cancelAnimationFrame(this._animationTop);
        this.requestAniTop = null;
      }
      this.doneTop = false;
      this.requestAniTop = window.requestAnimationFrame(this._animationTop);
      this._isDealingTop = true;
    }
  };

  /**
   * @description 添加滚动的动画
   * @param timeStamp
   * @private
   */
  _animationTop = (timeStamp) => {
    if (this.doneTop) {
      this.startTimeTop = 0;
      this.doneTop = false;
      window.cancelAnimationFrame(this._animationTop);
      this.requestAniTop = null;
      this._isDealingTop= false;
      return;
    }
    this.startTimeTop = this.startTimeTop || timeStamp;
    let progress = (timeStamp - this.startTimeTop) / 300;
    progress = FJCoreUtil.valueOfInterval(progress, 0, 1);

    let offset = (this.top - this.curTop) * this.easing(progress) + this.curTop;
    this.scroll.current.scrollTop(offset);

    if (progress === 1) {
      this.doneTop = true;
    }
    this.requestAniTop = window.requestAnimationFrame(this._animationTop)
  };

  /**
   * @description 监听正在滚动
   * @param e
   * @private
   */
  _onScroll = (e) => {
    if (this.props.onScroll) {
      this.props.onScroll(e);
    }
  };

  /**
   * @description 开始滚动
   * @param e
   * @private
   */
  _handleScrollStart = (e) => {
    if (this.props.handleScrollStart)
      this.props.handleScrollStart(e)
  };

  /**
   * @description 结束滚动
   * @param e
   * @private
   */
  _handleScrollStop = (e) => {
    if (this.props.handleScrollStop)
      this.props.handleScrollStop(e)
  };

  render() {
    let {
      children,
      trackVerticalClassName,
      trackHorizontalClassName,
      thumbVerticalClassName,
      thumbHorizontalClassName,
    } = this.props;
    return (
      <Scrollbars onScrollFrame={this.onScrollFrame}
                  onScroll={this._onScroll}
                  onScrollStart={this._handleScrollStart}
                  onScrollStop={this._handleScrollStop}
                  autoHide={false}
                  ref={this.scroll}
                  renderTrackVertical={props => <div {...props}
                                                     className={classNames(styles.scrollTrack, styles.scrollTrack_vertical, trackVerticalClassName)}/>}
                  renderTrackHorizontal={props => <div {...props}
                                                       className={classNames(styles.scrollTrack, styles.scrollTrack_horizontal, trackHorizontalClassName)}/>}
                  renderThumbVertical={props => <div {...props}
                                                     className={classNames(styles.scrollThumb, thumbVerticalClassName)}/>}
                  renderThumbHorizontal={props => <div {...props}
                                                       className={classNames(styles.scrollThumb, thumbHorizontalClassName)}/>}
      >
        {children}
      </Scrollbars>
    );
  }
}

export default FJCustomScroll;
